export default __webpack_public_path__ + "static/project-slide-8-768-700-1231f321f4c6759f1963f2ae032f8bd7.webp";